import IVeiculosRepository from '../repositories/IVeiculosRepository'

export interface IDeleteVeiculo {
  execute(id: number): Promise<void>
}

export default class DeleteVeiculoImpl implements IDeleteVeiculo {
  constructor(private readonly veiculoRepository: IVeiculosRepository) {}

  public async execute(id: number): Promise<void> {
    await this.veiculoRepository.delete(id)
  }
}
